"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _objectSpread2 = _interopRequireDefault(require("@babel/runtime/helpers/objectSpread"));

var _stencilReactDesc = require("@amzn/stencil-react-desc");

var _link = require("../link");

var _utils = require("../utils");

var _constants = require("./constants");

var MessageBannerLink = _link.Link.withComponent('a', {
  target: "e1mfx37y0"
});

MessageBannerLink.defaultProps = (0, _objectSpread2.default)({}, _link.Link.defaultProps, {
  color: _constants.TEXT_COLOR,
  fontSize: _constants.FONT_SIZE,
  fontWeight: 'medium'
});
var MessageBannerLinkWithDocs = (0, _stencilReactDesc.describe)(MessageBannerLink).description('Link component styled to fit in a message banner.');
MessageBannerLinkWithDocs.propTypes = (0, _objectSpread2.default)({}, _link.Link.describedPropTypes);
var MessageBannerLinkWithTestAttributes = (0, _utils.withTestAttributes)({
  component: 'MessageBannerLink'
})(MessageBannerLink);
MessageBannerLinkWithTestAttributes.displayName = 'MessageBannerLink';
var _default = MessageBannerLinkWithTestAttributes;
exports.default = _default;